// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import "@tailwindplus/elements"

// The board's poll controller guards turbo:frame-missing from connect() on,
// but Turbo can start the frame's eager src fetch during HTML parsing —
// before Stimulus attaches. A 5xx landing in that window would blank the
// board with "Content missing" and kill the poll trigger, with no recovery.
// Enforce the same keep-the-last-board policy at the document level, where
// the event lands even before the controller exists. Harmlessly redundant
// with the controller's own listener afterwards.
document.addEventListener("turbo:frame-missing", (event) => {
  if (event.target instanceof Element && event.target.matches("turbo-frame#pick-board")) {
    event.preventDefault()
  }
})

// Empty 401 responses never raise frame-missing, so handle lost access before
// Turbo tries to render the response or preserve the previous board.
document.addEventListener("turbo:before-fetch-response", (event) => {
  if (event.target instanceof Element && event.target.matches("turbo-frame#pick-board") &&
      event.detail.fetchResponse.response.status === 401) {
    event.preventDefault()
    window.location.assign("/login")
  }
})
